"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayableUpdateTransport = exports.PayableCreateTransport = exports.PayableTransport = exports.PayablePayoutSummary = exports.PAYABLE_TERM_OPTIONS = void 0;
const typebox_1 = require("@sinclair/typebox");
const invoice_transport_1 = require("./invoice-transport");
const payout_transport_1 = require("./payout-transport");
/** Allowed payment term values (days) for payables and hauler default. Shared by invoice and hauler. */
exports.PAYABLE_TERM_OPTIONS = [0, 15, 30, 45, 60];
// Lightweight payout summary for inclusion in payable transport
exports.PayablePayoutSummary = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    status: payout_transport_1.PayoutBatchStatus,
    paymentMethod: payout_transport_1.PayoutPaymentMethod,
    scheduledPayoutDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    totalAmount: typebox_1.Type.Integer({ minimum: 0 }),
    payableCount: typebox_1.Type.Integer({ minimum: 0 }),
});
exports.PayableTransport = typebox_1.Type.Object({
    invoiceDetails: invoice_transport_1.InvoiceTransport,
    id: typebox_1.Type.String(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    // Unified Billing superset: the payee (vendor) on a payable, for both brands post-remodel.
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    readyForPayment: typebox_1.Type.Boolean(),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    payout: typebox_1.Type.Optional(exports.PayablePayoutSummary),
});
exports.PayableCreateTransport = typebox_1.Type.Object({
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    invoiceDetails: typebox_1.Type.Intersect([
        invoice_transport_1.InvoiceCreateTransport,
        typebox_1.Type.Object({
            term: typebox_1.Type.Integer({ minimum: 0 }),
        }),
    ]),
});
exports.PayableUpdateTransport = typebox_1.Type.Object({
    // haulerID sent when updating hauler
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    // Unified Billing superset: the payee (vendor) on a payable.
    vendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoiceDetails: typebox_1.Type.Optional(invoice_transport_1.InvoiceUpdateTransport),
});
//# sourceMappingURL=payable-transport.js.map